import { getQaSelector } from '../../../../utils/common'

import * as styles from './BirdviewTileRowCarousel.module.css'

function BirdviewTileRowCarousel({ getItemId, items, qaName, renderItem }) {
  return (
    <div {...getQaSelector({ value: qaName })} className={styles.carousel}>
      {items.map(item => (
        <div className={styles.carouselItem} key={getItemId(item)}>
          {renderItem(item)}
        </div>
      ))}
    </div>
  )
}

export default BirdviewTileRowCarousel
